import { apiClient } from '../axios-instance'
import type { AxiosResponse } from 'axios'
import type { Wallet, PaginatedTransactions } from '../../../features/merchants/types/wallet.types'

export const walletsService = {
  /**
   * Get wallet balance for a merchant
   */
  getWallet: async (merchantId: string): Promise<Wallet> => {
    const response: AxiosResponse<{ success: boolean; data: Wallet }> = await apiClient.get(
      `/admin/wallets/${merchantId}`
    )
    return response.data.data
  },

  /**
   * Get transaction history for a merchant
   */
  getTransactions: async (merchantId: string, page = 1, perPage = 15): Promise<PaginatedTransactions> => {
    const response: AxiosResponse<{ success: boolean; data: any; pagination: any }> = await apiClient.get(
      `/admin/wallets/${merchantId}/transactions`,
      { params: { page, per_page: perPage } }
    )
    return {
      data: response.data.data,
      ...response.data.pagination
    }
  },

  /**
   * Manually credit merchant wallet
   */
  creditWallet: async (merchantId: string, data: { amount: number; description: string; reference_id?: string }): Promise<any> => {
    const response: AxiosResponse<{ success: boolean; data: any; message: string }> = await apiClient.post(
      `/admin/wallets/${merchantId}/credit`,
      data
    )
    return response.data.data
  },

  /**
   * Update/Set credit limit for a merchant's wallet
   */
  updateCreditLimit: async (merchantId: string, creditLimit: number): Promise<any> => {
    const response: AxiosResponse<{ success: boolean; data: any; message: string }> = await apiClient.post(
      `/admin/wallets/${merchantId}/credit-limit`,
      { credit_limit: creditLimit }
    )
    return response.data.data;
  },

  /**
   * Get overall platform ledger reconciliation status
   */
  getReconciliationStatus: async (): Promise<any> => {
    const response: AxiosResponse<{ success: boolean; data: any }> = await apiClient.get(
      '/admin/reconciliation/status'
    )
    return response.data.data
  },

  /**
   * Trigger double-entry reconciliation audit manually
   */
  triggerReconciliation: async (): Promise<any> => {
    const response: AxiosResponse<{ success: boolean; data: any; message: string }> = await apiClient.post(
      '/admin/reconciliation/trigger'
    )
    return response.data
  }
}
